import { useAppDispatch } from '../redux/hooks';
import { AppDispatch } from '../redux/store';

let dispatch: AppDispatch | null = null;
export const GlobalErrorConfiguration = () => {
    dispatch = useAppDispatch();
    return null;
};

export default {
    handleError(error) {
        // network errors, timeouts and requests cancelled by a page reload have no response -
        // reading .status here would throw a TypeError that masks the real error
        if (!error?.response) {
            return Promise.reject(error);
        }
        if (error.response.status === 404 && error.response.data?.length === 0) {
            return;
        } else {
            return Promise.reject(error);
        }
    },
};
